function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { getAppConfig } from '@shared/services/init/appConfig';
import AuthClient from './client';
import { getExtraScopesToConsent } from './scopes';
import { getImplicitRedirectUri } from './config';
import { getWindow } from '@shared/services/window';
import { logger } from '@src/logger';
import { stringifyError } from '@shared/utils/errorUtils';
import { Constants } from '@shared/utils/constants';
import { saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
const getRedirectStartPage = ({ to })=>{
    const redirectStartPage = new URL(to);
    redirectStartPage.searchParams.set(Constants.QueryStrings.Referer, getWindow().location.href);
    redirectStartPage.searchParams.set(Constants.QueryStrings.CorrelationId, getAppConfig('correlationId'));
    return redirectStartPage.href;
};
export const loginRedirectUser = ({ to, email })=>_async_to_generator(function*() {
        try {
            saveLocalStorageItem(Constants.LocalStorage.LoginHint, '');
            const authClient = AuthClient.getInstance();
            yield authClient.clearCache();
            yield authClient.loginRedirect({
                scopes: [],
                extraScopesToConsent: getExtraScopesToConsent(),
                loginHint: email,
                redirectUri: getImplicitRedirectUri(),
                redirectStartPage: getRedirectStartPage({
                    to
                }),
                correlationId: getAppConfig('correlationId')
            });
        } catch (error) {
            logger.error(stringifyError(error), {
                action: Constants.Telemetry.Action.Login,
                actionModifier: Constants.Telemetry.ActionModifier.PreAuthRedirectFailed,
                error
            });
        }
    })();
